import withInputFields from "../../helpers/inputfields";
import { USES_CHARGE_POLLING } from "../../../../charge/flags";
import { getValueAtPath, withProperties } from "../../../../utils";
import getChargeLimit from "../../../../lookup/limit";
import getChargeFee from "../../../../lookup/fee";

import InitView from "./views/init";
import ConfirmView from "./views/confirm";
import withReactiveFields from "../../helpers/reactivefields";
import RedirectView from "../../common/redirect";
import withCountdownTimer from "../../helpers/countdowntimer";
import PendingView from "../../common/pending";


const METHOD = 'mobilemoneymalawi';
const METHOD_NAME = 'Mobile Money';
const CHARGE_MODE = USES_CHARGE_POLLING;

const VIEWS = [ InitView, ConfirmView ];

function mount() {
    return (dispatch) => {
        getChargeLimit.call(this, () => {
            const VIEW = (
                this.REDIRECT_URL && (RedirectView || (this.REDIRECT_URL = null))
            ) || InitView;

            VIEW && VIEW.activate.call(this);
        });

        getChargeFee();
    };
}

function getChargeData() {
    return ({
        is_mobile_money_mw: true,
        payment_type: 'mobilemoneymw'
    });
}

function getViewsContext(data, store) {
    const TIMER_DURATION = 5 * 60;
    const REACTIVE_FIELDS = ['REDIRECT_URL', 'CURRENT_TIME', 'CAN_SWITCH_TO_CONFIRM'];
    const $context = withReactiveFields(Object.create(null), ...REACTIVE_FIELDS);

    $context.$subscribe('CAN_SWITCH_TO_CONFIRM', (currentValue, oldValue) => {
        setTimeout(() => {
        if (!(oldValue || oldValue === currentValue) && currentValue === true && typeof currentValue === 'boolean') {
            ConfirmView && ConfirmView.activate(() => {
            setTimeout(() => {
                $context.$charge.poll($context.pollConfig);
            }, 0);
            });
        }
        })
    })

    $context.$subscribe('REDIRECT_URL', (currentValue, oldValue) => {
        setTimeout(() => {
            if (!(oldValue && oldValue === currentValue) && currentValue instanceof URL) {
                RedirectView && RedirectView.activate.call($context);
            }
        }, 0);
    });

    withInputFields($context, {
        phone: getValueAtPath(data, 'phone') || null
    });

    withProperties($context, {
        TIMER_DURATION,
        $resetContext() {
            $context.REDIRECT_URL = null;
        },
        INIT_VIEW: callback => {
            InitView && InitView.activate(callback);
        }
    });

    return withCountdownTimer($context, {
        duration: TIMER_DURATION,
        onTick() { $context.CURRENT_TIME = $context.$timer.current },
        onFinish() {
            if ($context.$charge.cancel()) {
                $context.$timer && $context.$timer.clear();
                $context.CURRENT_TIME = null;
                $context.reference = null;
                $context.$resetContext();
                setTimeout(() => PendingView && PendingView.activate.call($context), 10)
            }
        }
    })
}

export {
    METHOD,
    METHOD_NAME,
    CHARGE_MODE,
    VIEWS,
    mount,
    getChargeData,
    getViewsContext
}